'use client';

import Container from '@/components/ui/Container/Container';

function SkeletonBlock({ className }: { className: string }) {
  return <div className={`animate-pulse rounded-[10px] bg-gray-200 ${className}`} />;
}

export default function GroupCompanySkeleton() {
  return (
    <main className="min-h-screen bg-[#f6f5f1] font-figtree">
      <Container size="xl" as="section" className="py-16 md:py-24">
        <SkeletonBlock className="h-14 w-2/3 md:h-20" />
        <SkeletonBlock className="mt-4 h-5 w-1/2" />
        <div className="mt-10 space-y-8">
          {[0, 1].map((i) => (
            <div
              key={i}
              className="grid grid-cols-1 gap-0 overflow-hidden rounded-2xl bg-white md:grid-cols-2"
            >
              <SkeletonBlock className="aspect-square w-full rounded-none" />
              <div className="space-y-4 p-8 md:p-10">
                <SkeletonBlock className="h-10 w-48" />
                <SkeletonBlock className="h-8 w-2/3" />
                <SkeletonBlock className="h-6 w-1/2" />
                <SkeletonBlock className="mt-4 h-4 w-full" />
                <SkeletonBlock className="h-4 w-full" />
                <SkeletonBlock className="h-4 w-3/4" />
                <SkeletonBlock className="mt-6 h-12 w-40 bg-red-200/60" />
              </div>
            </div>
          ))}
        </div>
      </Container>
    </main>
  );
}
